import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Badge, EmptyState } from "../AdminUI";
import { CreditCard, AlertTriangle } from "lucide-react";

const S = ({ label, value }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-4">
    <p className="text-2xl font-head font-extrabold text-[var(--navy)]">{value}</p>
    <p className="text-xs text-gray-500">{label}</p>
  </div>
);

export default function Financing() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/financing").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Client Financing</h1>
        <p className="text-gray-500 text-sm">Track EasyQuickFund financing referrals per lead.</p>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div className="text-sm text-amber-800">
          <p className="font-semibold">EasyQuickFund integration is inactive.</p>
          <p>Live application submission is disabled until approved credentials and disclosures are provided. You can still track referral status manually. Kill switch: <b>{data.kill_switch ? "Engaged" : "Off"}</b>.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <S label="Offered" value={data.stats.offered} /><S label="Links Sent" value={data.stats.link_sent} />
        <S label="Applications Started" value={data.stats.started} /><S label="Submitted" value={data.stats.submitted} />
        <S label="Approved" value={data.stats.approved} /><S label="Declined" value={data.stats.declined} />
        <S label="Funded" value={data.stats.funded} /><S label="Provider Connected" value={data.provider_connected ? "Yes" : "No"} />
      </div>

      <Card title="Financing Records">
        {data.leads.length === 0 ? <EmptyState icon={CreditCard} title="No financing records yet" hint="Set a financing status on any lead to track it here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-400 text-xs uppercase border-b border-gray-100">
                <th className="py-2 px-2">Customer</th><th className="px-2">Lead ID</th><th className="px-2">Project $</th><th className="px-2">Status</th><th className="px-2">Reference</th>
              </tr></thead>
              <tbody>
                {data.leads.map((l) => (
                  <tr key={l.id} className="border-b border-gray-50">
                    <td className="py-3 px-2 font-semibold text-[var(--navy)]">{l.name}</td>
                    <td className="px-2 text-gray-500">{l.lead_id}</td>
                    <td className="px-2">{l.estimated_value ? `$${l.estimated_value}` : "—"}</td>
                    <td className="px-2"><Badge color="blue">{l.financing_status}</Badge></td>
                    <td className="px-2 text-gray-400">{l.financing_ref || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
